import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'

class AuthRedirect extends Component{
    render(){
        return <Redirect to={this.props.loggedIn ? this.props.authTo : this.props.noAuthTo} />
    }
}

export default AuthRedirect;